import React from "react";

export default function ColorFrame38({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#000"
          d="M214.739 210.029c4.27-16.053 1.444-25.601 0-37.947 0 0-4.165-6.76-9.494 7.643-1.54 4.163-8.205 10.143-20.722 10.143-15.9 0-7.442-10.143-21.626-17.786-12.203-6.575-27.765-1.878-27.765-1.878v101.301c31.8 1.467 40.251-19.356 51.576-28.455 14.913-11.981 25.322-22.834 28.031-33.021z"
        ></path>
        <path
          fill="#000"
          d="M60.26 210.029c-4.269-16.053-1.443-25.601 0-37.947 0 0 4.166-6.76 9.495 7.643 1.54 4.163 8.205 10.143 20.722 10.143 15.9 0 7.442-10.143 21.626-17.786 12.203-6.575 27.765-1.878 27.765-1.878v101.301c-31.123 1.174-40.251-19.356-51.576-28.455-14.913-11.981-25.322-22.834-28.031-33.021z"
        ></path>
        <path
          fill="#fff"
          d="M163 193.506c0 6.709-9.58 3.919-23.387 3.919S113 200.215 113 193.506c0-4.065 4.108-7.663 10.417-9.868 4.104-1.435 9.438 0 14.881 0 5.442 0 10.181-1.435 14.285 0 6.309 2.205 10.417 5.803 10.417 9.868z"
        ></path>
        <path
          fill="#000"
          d="M155 4.316c-44.048-16.237-87.5 16.746-79 44.763 7.801 0 26.431-8.267 54.5 2 30.462 11.142 57.147 16.056 73-5 4.8-6.375 11-20.44 11-30.37 0-9.38-3.14-11.994-3.605-11.393-2.081 2.684-5.896 10.065-18.033 11.393-10.173 1.113-12.875-2.183-37.862-11.393z"
        ></path>
        <path
          fill="#000"
          d="M220.318 62.976c.277-9.98-13.173-13.747-21.145-13.862 0 0 2.083 5.198 4.509 16.982 1.712 8.314 1.595 26.566 2.769 33.963.495 3.12 2.201 4.284 2.773 2.08 2.426-9.358 10.747-26.686 11.094-39.163zM55.004 62.976c-.277-9.98 13.174-13.747 21.145-13.862 0 0-2.083 5.198-4.51 16.982-1.711 8.314-1.594 26.566-2.768 33.963-.495 3.12-2.201 4.284-2.773 2.08-2.426-9.358-10.747-26.686-11.094-39.163z"
        ></path>
        {children}
      </g>
    </svg>
  );
}
